import { Navigate } from 'react-router-dom';

import {
  adminLandingPath,
  useAdminSession,
} from '@/features/internal-admin/lib/admin-session';

// The index route: each division lands on the page it works from.
export const AdminLandingRedirect = () => {
  const { data: session } = useAdminSession();
  return <Navigate to={adminLandingPath(session?.division ?? null)} replace />;
};
